import React from 'react';
import AppLayout from '../../layout/app.layout';
import ChannelPreview from '../../components/content/channel-preview.component';

const ChannelPreviewView = () => {
  const pageTitle = 'Schedule Videos / Channel Preview';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ChannelPreview />
    </AppLayout>
  );
};

export default ChannelPreviewView;
